import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import {
  type InheritanceStepCriteria,
  type NewProcessAnalysisConfig,
  ProcessDataOriginEnum,
  type StepMatchingCriteria,
} from '../Processes/types'
import validator from '../Processes/validator'
import type { ProcessFormFields, StepCriteriaRow } from './types'

export const processFormSchema = yup
  .object({
    name: validator.trackedProcessName,
    process_identifier_name: validator.trackedProcessIdentifierName,
    process_category: validator.trackedProcessCategory,
    process_data_origin: yup.string(),

    initial_visible_variant_amount: validator.trackedProcessInitialVisibleVariantAmount,
    state_tag_key: validator.trackedProcessStateTagKey,
  })
  .required()

export const processFormResolver = yupResolver(processFormSchema)

const toApiStepCriteria = (row: StepCriteriaRow): InheritanceStepCriteria => {
  const { rowClientId: _rowClientId, ...criteria } = row
  return criteria
}

const includeRowInSavePayload =
  (rowIdsPendingFirstApply: ReadonlySet<string>) => (row: StepCriteriaRow) =>
    !rowIdsPendingFirstApply.has(row.rowClientId)

export function buildProcessAnalysisConfig(
  formData: ProcessFormFields,
  stepRows: {
    prev: StepCriteriaRow[]
    next: StepCriteriaRow[]
    multi: StepCriteriaRow[]
  },
  rowIdsPendingFirstApply: ReadonlySet<string>,
): NewProcessAnalysisConfig {
  const include = includeRowInSavePayload(rowIdsPendingFirstApply)

  return {
    name: formData.name,
    process_identifier_name: formData.process_identifier_name,
    process_category: formData.process_category,
    process_data_origin: ProcessDataOriginEnum.TASK_MINER,
    initial_visible_variant_amount: formData.initial_visible_variant_amount,
    state_tag_key: formData.state_tag_key,

    steps_inheriting_id_from_prev_window: stepRows.prev.filter(include).map(toApiStepCriteria),
    steps_inheriting_id_from_next_window: stepRows.next.filter(include).map(toApiStepCriteria),
    steps_inheriting_id_when_in_multi_system_flow: stepRows.multi
      .filter(include)
      .map(toApiStepCriteria) as StepMatchingCriteria[],
  }
}
